import { createClient } from '@sanity/client';
import groq from 'groq';

import { sanity, isDevelopment } from '../../client-config';

export const client = createClient({
  projectId: sanity.projectId,
  dataset: isDevelopment ? 'development' : 'production',
  useCdn: true, // set to `false` to bypass the edge cache
  apiVersion: '2024-11-22', // use current date (YYYY-MM-DD) to target the latest API version
});

export const clientPreview = createClient({
  projectId: sanity.projectId,
  dataset: isDevelopment ? 'development' : 'production',
  apiVersion: '2024-11-22', // use current date (YYYY-MM-DD) to target the latest API version
  overlayDrafts: true,
  perspective: 'previewDrafts',
  // Ideally, this token would not be exposed. However, this is only a Viewer token and should
  // be ok. Still, it should be prioritized to somehow include this token server-side
  token:
    'skJn0eCFEVQ2k7ea8ey8mQPf6XXseR3pFvauUBc4CgIlBs13oJwARIuXtmtgAPXL5VMIxZYltZDggsq37jjO86P6pHLMTzSrVy8N52q5JkOOEKqGINr9BecSnGxoHeSgObspVjU7OV2DT9lMP0wE2DnymyFhowGLYUrV2qexbiyvDBACvhIy',
});

export async function getIncidents({
  useDraft = false,
  onlyIncludeVisibleIncidents = true,
}: {
  useDraft: boolean;
  onlyIncludeVisibleIncidents?: boolean;
}) {
  let incidents = undefined;

  const query = onlyIncludeVisibleIncidents
    ? '_type == "hendelse" && (incidentSolved == false || (incidentSolved == true && defined(_updatedAt) && dateTime(_updatedAt) >= dateTime(now()) - 60*60*24))'
    : '_type == "hendelse"';

  // uses GROQ to query content: https://www.sanity.io/docs/groq
  if (useDraft)
    incidents = await clientPreview.fetch(groq`*[${query}]{..., routes[]->}`);
  else incidents = await client.fetch(groq`*[${query}]{..., routes[]->}`);

  return incidents;
}
